import { useCallback, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchAgreementNotes, NOTES_PER_PAGE } from '../services/agreementNotes';
import { agreementKeys } from './agreementKeys';

/** Page state is keyed by agreement id, so opening another agreement starts on page 1. */
export function useAgreementNotes(id: string | undefined, enabled: boolean) {
    const [pageState, setPageState] = useState({ id, page: 1 });
    const page = pageState.id === id ? pageState.page : 1;
    const setPage = useCallback((next: number) => setPageState({ id, page: next }), [id]);

    const query = useQuery({
        queryKey: agreementKeys.notesPage(id ?? '', page, NOTES_PER_PAGE),
        queryFn: () => fetchAgreementNotes(id!, { page, perPage: NOTES_PER_PAGE }),
        enabled: enabled && !!id,
        placeholderData: (previousData, previousQuery) =>
            previousQuery?.queryKey[2] === (id ?? '') ? previousData : undefined,
    });

    return { query, page, setPage };
}
